import { FormControl, FormLabel } from '@chakra-ui/react'
import type { PersonAdditionalData } from 'BrokerTsLib/src/dtos'
import { useFormContext } from 'BrokerTsLib/src/rhf'

import { InputGroup } from '../../../components/InputGroup'
import { useNameof } from '../../../hooks/useNameof'

function InsureeName({ personPrefix, disabled }: { personPrefix: string, disabled?: boolean }) {
  const pnameof = useNameof<PersonAdditionalData>(personPrefix)
  const { register, getFieldState } = useFormContext()

  const nameError = getFieldState(pnameof(x => x.name)).error
  const surnameError = getFieldState(pnameof(x => x.surname)).error

  return (
    <>
      <FormControl isInvalid={!!nameError}>
        <FormLabel>Jméno</FormLabel>

        <InputGroup
          {...register(pnameof(x => x.name))}
          autoComplete="given-name"
          placeholder="Např. Jana"
          errors={nameError}
          isDisabled={disabled}
        />
      </FormControl>

      <FormControl isInvalid={!!surnameError}>
        <FormLabel>Příjmení</FormLabel>

        <InputGroup
          {...register(pnameof(x => x.surname))}
          autoComplete="family-name"
          placeholder="Např. Nováková"
          errors={surnameError}
          isDisabled={disabled}

        />
      </FormControl>
    </>
  )
}

export default InsureeName